import * as React from 'react';
import MuiTableCell, { TableCellProps as MuiTableCellProps } from '@material-ui/core/TableCell';

export type DSTableCellProps = MuiTableCellProps;

export const DSTableCell: React.FC<DSTableCellProps> = MuiTableCell;
